module.exports = __webpack_public_path__ + "static/media/DF23-DevBadge-Speaker.6fb04c66.png";